<app-spinner></app-spinner>
<div class="bc-content-body">
  <router-outlet></router-outlet>
</div>
